import { render, staticRenderFns } from "./prnpolicy-add.vue?vue&type=template&id=b46c2edc"
import script from "./prnpolicy-add.vue?vue&type=script&lang=js"
export * from "./prnpolicy-add.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports